export enum EnumParaPpto {
  MONEDA1 = 'MONEDA1',
  DESCRIPCIONMONEDA1 = 'DESCRIPCIONMONEDA1',
  MONEDA2 = 'MONEDA2',
  DESCRIPCIONMONEDA2 = 'DESCRIPCIONMONEDA2',
  AREACLIENTE = 'AREACLIENTE',
  DEPARTAMENTOCLIENTE = 'DEPARTAMENTOCLIENTE',
  OTROSSOBRECOSTO = 'OTROSSOBRECOSTO',
  OTROSPARTIDAS = 'OTROSPARTIDAS',
  OTROREPORTE = 'OTROREPORTE',
  RESPALDARPORCORREO = 'RESPALDARPORCORREO',
  CALDECCU = 'CALDECCU',
  CALDECCANTPPTO = 'CALDECCANTPPTO',
  CALDECEXPINS = 'CALDECEXPINS',
  CALTIPOEXPINS = 'CALTIPOEXPINS',
  CALMOSTRARERRPOT = 'CALMOSTRARERRPOT',
  CALTASAINTERES = 'CALTASAINTERES',
  CALORDENARMATXTIPOINS = 'CALORDENARMATXTIPOINS',
  CALASIGNARFECHAINS = 'CALASIGNARFECHAINS',
  CALFECHAINS = 'CALFECHAINS',
  CALPARAMONEDAS = 'CALPARAMONEDAS',
  CALFACTORM1 = 'CALFACTORM1',
  CALFACTORM2 = 'CALFACTORM2',
  CALEXPINSXCONCEPTO = 'CALEXPINSXCONCEPTO',
  CALPROGSUM = 'CALPROGSUM',
  CALEXPLOTARINSCH = 'CALEXPLOTARINSCH',
  CALNOEXPLOTARINSINT = 'CALNOEXPLOTARINSINT',
  PPTOCOSTOTOTAL = 'PPTOCOSTOTOTAL',
  PPTOPRECIOTOTAL = 'PPTOPRECIOTOTAL',
  PPTOPORCSOBRECOSTO = 'PPTOPORCSOBRECOSTO',
  URLCONTENIDO = 'URLCONTENIDO',
  PPTOMAESTROVINCULADO = 'PPTOMAESTROVINCULADO',
  LICFECHALICITACION = 'LICFECHALICITACION',
  LICNUMLICITACION = 'LICNUMLICITACION',
  LICLUGARCELEBRACION = 'LICLUGARCELEBRACION',
  LICNUMCONVOCATORIA = 'LICNUMCONVOCATORIA',
  LICFECHAPUBLICACION = 'LICFECHAPUBLICACION',
  LICFECHAINICIO = 'LICFECHAINICIO',
  LICFECHAFINAL = 'LICFECHAFINAL',

  SCFACTORSFP1 = 'SCFACTORSFP1',
  SCINDICADORREFERENCIA1 = 'SCINDICADORREFERENCIA1',
  SCPORCENTAJEUTILIDADPROPUESTA1 = 'SCPORCENTAJEUTILIDADPROPUESTA1',
  SCTASAINITERES1 = 'SCTASAINITERES1',
  SCPUNTOSBANCO1 = 'SCPUNTOSBANCO1',
  SCPORCENTAJEANTICIPO11 = 'SCPORCENTAJEANTICIPO11',
  SCIMPORTEMOGRAVABLE1 = 'SCIMPORTEMOGRAVABLE1',
  SCPERIODOENTREGAANTICIPO21 = 'SCPERIODOENTREGAANTICIPO21',
  SCPROGRAMA1 = 'SCPROGRAMA1',
  SCTIPOANTICIPO1 = 'SCTIPOANTICIPO1',
  SCPORCENTAJEANTICIPO21 = 'SCPORCENTAJEANTICIPO21',
  SCIMPORTEEJERCICIO11 = 'SCIMPORTEEJERCICIO11',

  SOBNOMBRELIBROSC1 = 'SOBNOMBRELIBROSC1',
  SOBNOMBRELIBROPI1= 'SOBNOMBRELIBROPI1',
  SOBINDIRECTOTOTAL1 = 'SOBINDIRECTOTOTAL1',
  SOBFINANCIAMIENTO1 = 'SOBFINANCIAMIENTO1',
  SOBINDIRECTOCAMPO1 = 'SOBINDIRECTOCAMPO1',
  SOBUTILIDAD1 = 'SOBUTILIDAD1',
  SOBINDIRECTOOFICINA1 = 'SOBINDIRECTOOFICINA1',
  SOBCARGOSADICIONALES1 = 'SOBCARGOSADICIONALES1',

  SCFACTORSFP2 = 'SCFACTORSFP2',
  SCINDICADORREFERENCIA2 = 'SCINDICADORREFERENCIA2',
  SCPORCENTAJEUTILIDADPROPUESTA2 = 'SCPORCENTAJEUTILIDADPROPUESTA2',
  SCTASAINITERES2 = 'SCTASAINITERES2',
  SCPUNTOSBANCO2 = 'SCPUNTOSBANCO2',
  SCPORCENTAJEANTICIPO12 = 'SCPORCENTAJEANTICIPO12',
  SCIMPORTEMOGRAVABLE2 = 'SCIMPORTEMOGRAVABLE2',
  SCPERIODOENTREGAANTICIPO22 = 'SCPERIODOENTREGAANTICIPO22',
  SCPROGRAMA2 = 'SCPROGRAMA2',
  SCTIPOANTICIPO2 = 'SCTIPOANTICIPO2',
  SCPORCENTAJEANTICIPO22 = 'SCPORCENTAJEANTICIPO22',
  SCIMPORTEEJERCICIO12 = 'SCIMPORTEEJERCICIO12',

  SOBNOMBRELIBROSC2 = 'SOBNOMBRELIBROSC2',
  SOBNOMBRELIBROPI2= 'SOBNOMBRELIBROPI2',
  SOBINDIRECTOTOTAL2 = 'SOBINDIRECTOTOTAL2',
  SOBFINANCIAMIENTO2 = 'SOBFINANCIAMIENTO2',
  SOBINDIRECTOCAMPO2 = 'SOBINDIRECTOCAMPO2',
  SOBUTILIDAD2 = 'SOBUTILIDAD2',
  SOBINDIRECTOOFICINA2 = 'SOBINDIRECTOOFICINA2',
  SOBCARGOSADICIONALES2 = 'SOBCARGOSADICIONALES2',
  SOBPORCENTAJESOBRECOSTO2 = 'SOBPORCENTAJESOBRECOSTO2',

  CHDEPRECIACIONE = 'CHDEPRECIACIONE',
  CHDEPRECIACIONR = 'CHDEPRECIACIONR',
  CHINVERSIONE = 'CHINVERSIONE',
  CHINVERSIONR = 'CHINVERSIONR',
  CHSEGUROSE = 'CHSEGUROSE',
  CHSEGUROSR = 'CHSEGUROSR',
  CHMANTENIMIENTOE = 'CHMANTENIMIENTOE',
  CHMANTENIMIENTOR = 'CHMANTENIMIENTOR',
  CHCOMBUSTIBLEE = 'CHCOMBUSTIBLEE',
  CHCOMBUSTIBLER = 'CHCOMBUSTIBLER',
  CHLUBRICANTESE = 'CHLUBRICANTESE',
  CHLUBRICANTESR = 'CHLUBRICANTESR',
  CHLLANTASE = 'CHLLANTASE',
  CHLLANTASR = 'CHLLANTASR',
  CHPIEZAESPE = 'CHPIEZAESPE',
  CHPIEZAESPR = 'CHPIEZAESPR',
  CHOPERACIONE = 'CHOPERACIONE',
  CHOPERACIONR = 'CHOPERACIONR',
  CHOTRASFUENTESENERGIAE = 'CHOTRASFUENTESENERGIAE',
  CHOTRASFUENTESENERGIAR = 'CHOTRASFUENTESENERGIAR',
  CHINDREFERENCIA = 'CHINDREFERENCIA',
  CHINDESPECIFICOSEGUROS = 'CHINDESPECIFICOSEGUROS',
  CHFACTORLUBRICANTEP0 = 'CHFACTORLUBRICANTEP0',
  CHFACTORLUBRICANTEPMAYOR0 = 'CHFACTORLUBRICANTEPMAYOR0',
  CHFACTORCOMBUTIBLEGASOLINA = 'CHFACTORCOMBUTIBLEGASOLINA',
  CHFACTORCOMBUTIBLEDIESEL = 'CHFACTORCOMBUTIBLEDIESEL',
  CHFACTORCOMBUTIBLEOTROS = 'CHFACTORCOMBUTIBLEOTROS',
  CHNOMBRELIBROCH = 'CHNOMBRELIBROCH',
  CHTIENELIBROCH = 'CHTIENELIBROCH',
  FANIOAPLICACION = 'FAÑOAPLICACION',
  FSALARIOMINIMO = 'FSALARIOMINIMO',
  FUMA = 'FUMA',
  FNOMINA = 'FNOMINA',
  FPAGOSTERCEROS = 'FPAGOSTERCEROS',
  FSAR = 'FSAR',
  FINFONAVIT = 'FINFONAVIT',
  FCONSIDERARPRESTACIONES = 'FCONSIDERARPRESTACIONES',
  FRIESGOTRABAJO = 'FRIESGOTRABAJO',
  FNOMBRELIBRO = 'FNOMBRELIBRO',
  FANIOAPLICACION2 = 'FAÑOAPLICACION2',
  FSALARIOMINIMO2 = 'FSALARIOMINIMO2',
  FUMA2 = 'FUMA2',
  FNOMINA2 = 'FNOMINA2',
  FPAGOSTERCEROS2 = 'FPAGOSTERCEROS2',
  FSAR2 = 'FSAR2',
  FINFONAVIT2 = 'FINFONAVIT2',
  FCONSIDERARPRESTACIONES2 = 'FCONSIDERARPRESTACIONES2',
  FRIESGOTRABAJO2 = 'FRIESGOTRABAJO2',
  FNOMBRELIBRO2 = 'FNOMBRELIBRO2',
  IDPROGRAMA = 'IDPROGRAMA'
}

export enum EnumParaOrg {
  TIPOCONCEPTO = 'TIPOCONCEPTO',
  TIPOMATRIZ = 'TIPOMATRIZ',
  UNIINSESPRES = 'UNIINSESPRES',
  UNIINSLLANTAS = 'UNIINSLLANTAS',
  UNIINSPZAESP = 'UNIINSPZAESP',
  UNIINSCOMBUSTIBLEEQ = 'UNIINSCOMBUSTIBLEEQ',
  UNIINSLUBEQ = 'UNIINSLUBEQ',
  UNIVALORADQEQ = 'UNIVALORADQEQ',
  UNIPOTENCIACH = 'UNIPOTENCIACH',
  LOGO = 'LOGO',
  NUMCODCONSECUTIVO = 'NUMCODCONSECUTIVO',
  SOLOADMINVERCORREOSORG = 'SOLOADMINVERCORREOSORG'
}

export enum EnumParaUsu {
  LIMITEBUSQGRAL = 'LIMITEBUSQGRAL',
  ULTIMOPPTOABIERTO = 'ULTIMOPPTOABIERTO',
  ULTIMOPPTOMAESTROABIERTO = 'ULTIMOPPTOMAESTROABIERTO',
  PPTOANCALDO1 = 'PPTOANCALDO1',
  PPTOANCALDO2 = 'PPTOANCALDO2',
  PPTOANCALDO3 = 'PPTOANCALDO3',
  PPTOMAESTROANCALDO1 = 'PPTOMAESTROANCALDO1',
  PPTOMAESTROANCALDO2 = 'PPTOMAESTROANCALDO2',
  PPTOMAESTROANCALDO3 = 'PPTOMAESTROANCALDO3',
  IDIOMA = 'ES',
  TEMA = 'light-theme',
  MOSTRAREXPINSACOPLADO = 'MOSTRAREXPINSACOPLADO',
  FILTROCIUDADCATBUSGRAL = 'FILTROCIUDADCATBUSGRAL',
  FILTROCIUDADCAT = 'FILTROCIUDADCAT',
  FILTROCIUDADCATMAESTRO = 'FILTROCIUDADCATMAESTRO',
  DIASACOMPARTIRPPTO = 'DIASACOMPARTIRPPTO'
}

export enum EnumVtnOpcionesReportes {
  CONFIGVTNREPORTES= 'ConfigVtnReportes',
  INSUMOS = 'INSUMOS',
  RESUMENDEINSUMOS = 'RESUMENDEINSUMOS',
  MATRICES = 'MATRICES',
  MATRICESDEBASICOS = 'MATRICESDEBASICOS',
  PRESUPUESTO = 'PRESUPUESTO',
  RESUMENDELPRESUPUESTO = 'RESUMENDELPRESUPUESTO',
  COSTOHORARIO = 'COSTOHORARIO',
  OBRAPORCONCEPTO = 'OBRAPORCONCEPTO',
  OBRAPORPARTIDA = 'OBRAPORPARTIDA',
  SUMINISTROPORCONCEPTO = 'SUMINISTROPORCONCEPTO',
  SUMINISTROPORPARTIDA = 'SUMINISTROPORPARTIDA',
  EQUIPOEMRT = 'EQUIPOEMRT',
  EQUIPOTMRT = 'EQUIPOTMRT',
  MANOOBRAEMRT = 'MANOOBRAEMRT',
  MANOOBRATMRT = 'MANOOBRATMRT',
  MATERIALESEMRT = 'MATERIALESEMRT',
  MATERIALETMRT = 'MATERIALETMRT'
}

export enum EnumLibros {
  CH = 'CH',
  SC = 'SC',
  FASAR = 'FASAR',
  PI = 'PI'
}
